<template>
  <div class="text-center" style="margin-top:20%">
    <v-progress-circular
        color="#11679a"
      :size="70"
      :width="7"
      indeterminate
    ></v-progress-circular>
  </div>
</template>
<script>
import { EventBus } from '../../../../helpers/eventbus/event-bus'
export default {
    data(){
        return{
            userstorage: null,
            token:null
        }
    },
    mounted(){
        this.userstorage  = JSON.parse(localStorage.getItem('iden'))
        //console.log(this.userstorage)
        this.token = this.$route.params.token
        let iduser=this.$route.params.id
        //console.log(this.token)
        
            this.axios.put('users/validateuseremail',{
                token:this.token,
                id:iduser
            })
            .then((res) => {
                localStorage.removeItem('user')
                /*
                let userdata = JSON.parse(localStorage.getItem('user'))
                userdata.start_time_block =  ""
                userdata.verificate_status_email =  true
                */
                //localStorage.setItem('user',JSON.stringify(userdata))
                //EventBus.$emit('getuser')
                window.location = '/'
                //console.log(userdata)
                
            })
            .catch(()=>{
                window.location = '/'
            })
            
    },
    methods:{

    }
}
</script>
<style scoped>
    .v-progress-circular {
    margin: 1rem;
    }
</style>
